module.exports = ".privacy-container {\n  padding-bottom: 128px;\n  padding-left: 0;\n  width: 100%;\n  min-height: 100vh;\n  overflow: hidden;\n  margin-top: -80px; }\n  .privacy-container .privacy-section {\n    position: relative;\n    margin-top: 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/privacy-notice/privacy-notice.component.scss
// module id = ./src/app/shared/components/privacy-notice/privacy-notice.component.scss
// module chunks = main